import { useCallback, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import {
  setLoadingType,
  setPasswordScreen,
} from "../../../../components/dataflow/utils-module";
import {
  resetPassword as resetPasswordThunk,
  sendResetPasswordMail,
} from "../../dataflow/auth-thunk";

export function useResetPassword() {
  const dispatch = useDispatch();
  const history = useHistory();
  const isLoading = useSelector((state) => state.utils.isLoading);
  const passwordScreen = useSelector((state) => state.utils.passwordScreen);

  const [email, setEmail] = useState("");

  const isRecoverStep = passwordScreen === "password-recover";
  const isSubmitting = isLoading.type === "recover-password";

  const title = useMemo(
    () => (isRecoverStep ? "Alterar senha" : "Recuperar senha"),
    [isRecoverStep]
  );

  const description = useMemo(() => {
    if (!isRecoverStep) return "Insira o e-mail para receber o código.";
    if (!email) return "Insira o código e defina uma nova senha.";
    return `Cole abaixo o código de confirmação enviado para ${email}.`;
  }, [email, isRecoverStep]);

  const goToLogin = useCallback(() => {
    history.push("/");
  }, [history]);

  const onBackFromRecoverStep = useCallback(() => {
    dispatch(setPasswordScreen("password-reset"));
    history.push("/");
  }, [dispatch, history]);

  const onSubmitEmail = useCallback(
    ({ email: nextEmail }) => {
      setEmail(nextEmail);
      dispatch(setLoadingType({ type: "recover-password" }));
      dispatch(sendResetPasswordMail(nextEmail));
    },
    [dispatch]
  );

  const onSubmitRecover = useCallback(
    ({ confirmationCode, password, confirmPassword }) => {
      if (!email) return;
      dispatch(
        resetPasswordThunk(
          email,
          password,
          confirmationCode,
          confirmPassword,
          history
        )
      );
    },
    [dispatch, email, history]
  );

  const onResendMail = useCallback(() => {
    if (!email) return;
    dispatch(setLoadingType({ type: "recover-password" }));
    dispatch(sendResetPasswordMail(email));
  }, [dispatch, email]);

  return {
    isRecoverStep,
    isSubmitting,
    title,
    description,
    onSubmitEmail,
    onSubmitRecover,
    goToLogin,
    onBackFromRecoverStep,
    onResendMail,
    hasEmail: Boolean(email),
  };
}
